import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import LoadingIndicator from "components/atoms/LoadingIndicator";

const EmptyPanel = ({
  panelKey,
  width = 1,
  isFinal,
  isLoading,
  finalText = "Keine Einträge",
  continueText = "Weiter eingrenzen",
  className,
}) => {
  const componentBaseClass = "sal-spacer-panel";
  const componentLegacyClass = "sal-panel";
  const componentClassName = classnames(
    componentBaseClass,
    componentLegacyClass,
    { [`${componentBaseClass}--size-${width}`]: width !== 1 },
    className,
  );
  const content = isFinal ? finalText : continueText;

  return (
    <div className={componentClassName}>
      {isLoading ? (
        <LoadingIndicator
          onDark
          className={`${componentBaseClass}__loading-indicator`}
        />
      ) : (
        [
          !isFinal && (
            <h3
              className={`${componentBaseClass}__caption`}
              key="empty-panel-caption"
            >
              {panelKey}. Schritt
            </h3>
          ),
          <span
            className={`${componentBaseClass}__text`}
            key="empty-panel-text"
          >
            {content}
          </span>,
        ]
      )}
    </div>
  );
};

EmptyPanel.propTypes = {
  className: PropTypes.string,
  continueText: PropTypes.string,
  finalText: PropTypes.string,
  isFinal: PropTypes.bool,
  isLoading: PropTypes.bool,
  panelKey: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
};

export default EmptyPanel;
